<template>
  <nav id="navbar" class="w-full bg-white border-b border-neutral-200">

    <div
        class="flex items-center justify-between py-3 mx-auto w-full max-w-6xl px-5 md:px-8 xl:px-0">

      <Logo :url="homepageUrl" @click="handleLogoClick" />

      <div class="flex items-center">
        <LangDropdown class="flex h-8 md:h-9 text-sm" dark/>

        <!--        <BaseButton v-if="!loggedIn"-->
        <!--                    class="ml-3 h-9 text-xs md:text-sm md:h-auto" round>-->
        <!--          Entrar-->
        <!--        </BaseButton>-->
      </div>

    </div>

  </nav>
</template>

<script setup lang="ts">
const { homepageUrl, handleLogoClick } = useExitModal()
</script>

<style>
.logo-navbar svg {
  height: 21px;
}
</style>
